import { defineStore } from 'pinia';

interface LoaderState {
  loadingProcesses: Set<string>;
}

export const useLoaderStore = defineStore('loaderStore', {
  state: (): LoaderState => ({
    loadingProcesses: new Set(),
  }),
  getters: {
    isLoading(): boolean {
      return this.loadingProcesses.size > 0;
    },
    getLoadingCount(): number {
      return this.loadingProcesses.size;
    },
  },
  actions: {
    startLoading(processName: string) {
      this.loadingProcesses.add(processName);
    },
    stopLoading(processName: string) {
      this.loadingProcesses.delete(processName);
    },
  },
});
